import { createCtx, Timestamp } from '@mi-front/core';

export const [useHoveredTs, HoveredTsCtxProvider] = createCtx<Timestamp | null>();
